import { useState } from "react";
import { Button, Input } from "@material-tailwind/react";
import { t } from "i18next";

/**
 * Interface pour les propriétés du composant HoseDraftRow
 */
interface HoseDraftRowProps {
  onSave: (data: {
    name: string;
    description?: string;
    qrCode: string;
  }) => Promise<void>;
  onCancel: () => void;
}

/**
 * Composant pour l'ajout inline d'un flexible dans un workorder
 * Affiche une ligne d'édition avec les champs pour un nouveau flexible
 */
export default function HoseDraftRow({ onSave, onCancel }: HoseDraftRowProps) {
  const [name, setName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  //const [barCode, setBarCode] = useState<string>("");
  const [qrCode, setQrCode] = useState<string>("");

  /**
   * Gère la soumission du formulaire
   */
  const handleSaveClick = async () => {
    if (!name.trim()) {
      alert(t("workorder:hoses:noName"));
      return;
    }

    setLoading(true);
    try {
      await onSave({
        name: name.trim(),
        qrCode: qrCode,
      });
    } catch (error) {
      console.error(t("workorder:errors:addHose"), error);
      alert(t("workorder:errors:addHose"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shadow-sm">
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <Input
            label={t("workorder:hoses:name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-white"
            required
          />
        </div>


        <div> 
          <Input
            label={t("workorder:hoses:qrCode")}
            value={qrCode}
            onChange={(e) => setQrCode(e.target.value)}
            className="bg-white"
          />
        </div>

        <div className="flex justify-end gap-2 mb-2">
          <Button
            variant="filled"
            size="md"
            color="white"
            className="btn-cancel normal-case font-thin border"
            onClick={onCancel}
            disabled={loading}
          >
            {t("workorder:hoses:cancel")}
          </Button>
          <Button
            variant="filled"
            className="bg-blue-500 normal-case font-thin"
            onClick={handleSaveClick}
            disabled={loading}
          >
            {loading ? t("workorder:hoses:saving") : t("workorder:hoses:save")}
          </Button>
        </div>
      </div>
    </div>
  );
}
